export default __webpack_public_path__ + "static/media/radiant-bright-purple-blue.10e86967.jpg";